import React from "react";

import {
  Container,
  Grid,
  Typography,
  CircularProgress,
} from "@material-ui/core";

// import useStyles from "../styles";

const LoadingServerView = () => {
  // const classes = useStyles();

  return (
    <Container maxWidth={"xs"}>
      <Grid
        container
        style={{ marginTop: "10vh" }}
        alignItems="center"
        direction="column"
        justify="center"
      >
        <Grid item container spacing={5} justify="center">
          <Grid item container xs={12} justify="center">
            <Grid item>
              <Typography align="center" variant="h4">
                Carregando servidor...
              </Typography>
              <Typography
                variant="body1"
                align="center"
                color="textSecondary"
                style={{ marginTop: "1.21rem" }}
              >
                (isto pode demorar até cerca de 1 minuto)
              </Typography>
            </Grid>
          </Grid>
          <Grid item container xs={12} justify="center">
            <Grid item>
              <CircularProgress size="7vh" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default LoadingServerView;
